import React from 'react'
import clsx from 'clsx'
import { Control, Path, useFormContext } from 'react-hook-form'

import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@/components/form/Form'
import { Checkbox } from '@/components/form/form-checkbox/Checkbox'
import { Box } from '@/components/layout/box'
import { Stack } from '@/components/layout/stack'

import * as styles from './FormCheckbox.css'

type Props<T> = {
	name: Path<T>
	label?: string
	description?: string
	disabled?: boolean
	boldLabel?: boolean
	className?: string
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const FormCheckbox = <T extends object>({ boldLabel = false, onChange, ...props }: Props<T>) => {
	const form = useFormContext<T>()

	return (
		<FormField
			control={form.control as Control}
			name={props.name}
			render={({ field }) => (
				<FormItem className={props.className}>
					<Stack gap={1}>
						<Box display="flex" alignItems="center" gap={2} className={clsx(!props.disabled && styles.pointer)}>
							<FormControl>
								<Checkbox
									disabled={props.disabled}
									checked={field.value}
									onCheckedChange={checked => {
										if (onChange) {
											onChange({ target: { checked } } as React.ChangeEvent<HTMLInputElement>)
										} else {
											field.onChange(checked)
										}
									}}
									aria-label={field.value === true ? 'Checked' : 'Unchecked'}
								/>
							</FormControl>
							{props.label && <FormLabel className={clsx(!boldLabel && styles.regular)}>{props.label}</FormLabel>}
						</Box>
						{props.description && <FormDescription>{props.description}</FormDescription>}
						<FormMessage />
					</Stack>
				</FormItem>
			)}
		/>
	)
}
